import { render, staticRenderFns } from "./NewCustomerComponent.vue?vue&type=template&id=8f8e9c60&scoped=true"
import script from "./NewCustomerComponent.vue?vue&type=script&lang=js"
export * from "./NewCustomerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8e9c60",
  null
  
)

export default component.exports